module.exports = __webpack_public_path__ + "static/assets/13500146af7699e67f893e1f68c6eac5.gif";